import React from 'react';
import Block from '../../design-system/chat-blocks/Block';
import Pill from '../../design-system/primitives/Pill';
import { fmtInt, fmtUsd } from './format';

const hours = (h) => (h < 1 ? `${Math.round(h * 60)} min` : `${h.toFixed(1)} h`);

const GpuCostBlock = ({ gpu, windowLabel }) => (
  <Block
    icon="zap"
    title="Predictive engine GPU time"
    badge={<Pill tone="accent">{fmtUsd(gpu.cost_usd)} all time</Pill>}
    footer={<span>At {fmtUsd(gpu.rate_usd_per_hour)} per GPU hour. Training time is measured on the engine; API prediction and forecast time is the job's wall-clock, so it is an upper bound. Chat and pipeline forecasts run on the webserver and cost no GPU time.</span>}
  >
    <div className="qa-gpu-grid">
      <div className="qa-gpu-cell">
        <div className="qa-gpu-cell__label">Training</div>
        <div className="qa-gpu-cell__value">{fmtUsd(gpu.training.cost_usd)}</div>
        <div className="qa-gpu-cell__sub">{fmtInt(gpu.training.runs)} runs · {hours(gpu.training.hours)} · {fmtUsd(gpu.training.window_cost_usd)} in {windowLabel}</div>
      </div>
      <div className="qa-gpu-cell">
        <div className="qa-gpu-cell__label">API predictions and forecasts</div>
        <div className="qa-gpu-cell__value">{fmtUsd(gpu.inference.cost_usd)}</div>
        <div className="qa-gpu-cell__sub">{fmtInt(gpu.inference.runs)} runs · {hours(gpu.inference.hours)} · {fmtUsd(gpu.inference.window_cost_usd)} in {windowLabel}</div>
      </div>
    </div>
  </Block>
);

export default GpuCostBlock;
